import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import { IoMdClose } from 'react-icons/io';

export default function SimpleModal({
  children, open, setOpen, modalWidth,
}) {
//   const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log('modalWidth',modalWidth);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: modalWidth === 800 ? '800px' : ,
    bgcolor: 'background.paper',
    // border: '1px solid #000',
    borderRadius: '4px',
    boxShadow: 24,
    // p: 4,
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: { backgroundColor: 'rgba(15, 23, 42, 0.45)', backdropFilter: 'blur(2px)' },
        }}
      >
        <Fade in={open}>
          <Box className="absolute left-[50%] top-[50%] max-h-[92vh] w-[calc(100%-24px)] max-w-[800px] -translate-x-[50%] -translate-y-[50%] overflow-y-auto rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200 outline-none">
            <Button
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 12,
                top: 12,
                zIndex: 1,
                minWidth: 0,
                width: 36,
                height: 36,
                p: 0,
                fontSize: '20px',
                color: '#64748b',
                borderRadius: '10px',
                '&:hover': { backgroundColor: '#f1f5f9', color: '#0f172a' },
              }}
            >
              <IoMdClose />
            </Button>
            {children}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
